import axios from '@/utils/axios';
import { debounce, throttle } from '@isyscore/utils/func';

export const getFrontView = async () => {
    try {
        const { frontView } = await axios.get('/api/ops/config/user/desktop/getUserConfig');
        return JSON.parse(frontView);
    } catch (err) {
        return [];
    }
};

export const smoothUpdateTileLayout = throttle(
    async (tileLayout) => {
        try {
            await updateTileLayout(tileLayout);
        } catch (err) {
            // ignore
        }
    },
    1000,
    true
);

export const updateTileLayout = async (tileLayout) => {
    const data = { frontView: JSON.stringify(tileLayout) };
    return await axios.post('/api/ops/config/user/desktop/insertOrUpdate', data);
};
